import { Box, SxProps, Theme } from "@mui/material"
import ArrowDropDownRoundedIcon from "@mui/icons-material/ArrowDropDownRounded"
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded"
import React, { useCallback } from "react"
import { StatusDisable, StatusValidation } from "components/status"
import { RfidCellComponent, RfidsTableColumnsType, } from "types/rfid"
import { SORTORDER, SortOrder } from "types/sort"
import { StyledTableCell } from "components/tables/StyledTable"
import { RfidStatus } from "layouts/rfid/utils/const.ts"

export const CardHolderRfidCell: RfidCellComponent = ({ rfid }) => {
    return <>{rfid.cardHolder}</>
}

export const StatusRfidCell: RfidCellComponent = ({ rfid, sx = {} }) => {
    const baseSx: SxProps<Theme> = {
        paddingLeft: "0rem",
        paddingRight: "0rem",
    };

    const statusProps = {
        text: rfid.status === RfidStatus.Active ? "Active" : "Désactivée",
        sx: { ...baseSx, ...sx } as SxProps<Theme>
    };

    return rfid.status === RfidStatus.Active ? (
        <StatusValidation {...statusProps} />
    ) : (
        <StatusDisable {...statusProps} />
    );
};

export const RfidHeaderCell = ({
    keyRfid,
    title,
    width,
    orderBy,
    sortOrder,
    setOrderBy,
    setSortOrder,
    isSortable
}: {
    keyRfid: keyof RfidsTableColumnsType
    title: string
    width: string
    sortOrder: SortOrder
    orderBy: keyof RfidsTableColumnsType
    setSortOrder: React.Dispatch<React.SetStateAction<SortOrder>>
    setOrderBy: React.Dispatch<
        React.SetStateAction<keyof RfidsTableColumnsType>
    >
    isSortable: boolean
}) => {
    const onSort = useCallback(
        (orderBy: keyof RfidsTableColumnsType) => {
            if (isSortable) {
                setOrderBy(orderBy)
                setSortOrder((sortOrder: SortOrder) =>
                    sortOrder === SORTORDER.ASC ? SORTORDER.DESC : SORTORDER.ASC
                )
            }
        },
        [setOrderBy, setSortOrder]
    )
    return (
        <StyledTableCell
            onClick={() => onSort(keyRfid)}
            sx={{
                width: width,
                cursor: isSortable ? "pointer" :"default",
            }}
        >
            <Box
                sx={{
                    position: "relative",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: orderBy !== keyRfid ? "calc(100% + 0.5rem)" : "100%",
                    gap:'1rem'
                }}
            >
                {title}
                {orderBy === keyRfid && sortOrder === SORTORDER.ASC && (
                    <ArrowDropUpRoundedIcon
                        sx={{
                            p: 0,
                            m: 0,
                            height: "0.5rem",
                            width: "0.5rem",
                            transform: "scale(3.5)",
                            color: "grey.600",
                        }}
                        data-testid="arrow-up-sort-table-rfid"
                    />
                )}
                {orderBy === keyRfid && sortOrder === SORTORDER.DESC && (
                    <ArrowDropDownRoundedIcon
                        sx={{
                            p: 0,
                            m: 0,
                            height: "0.5rem",
                            width: "0.5rem",
                            transform: "scale(3.5)",
                            color: "grey.600",
                        }}
                        data-testid="arrow-down-sort-table-rfid"
                    />
                )}
            </Box>
        </StyledTableCell>
    )
}